export const noemirProductVersion = '0.1.1' as const;
